export const cmsFiltersColumns = [
    {
        headerName: "Fit5",
        field: "fit5",
        width: 160,
    },
    {
        headerName: "Strong60",
        field: "strong60",
        width: 160,
    },
    {
        headerName: "Enquiries",
        field: "enquiries",
        width: 160
    },
    {
        headerName: "Renewals",
        field: "renewals",
        width: 160,
    },
    {
        headerName: "UpcomingDemos",
        field: "upcomingDemos",
        width: 160,
    },
    {
        headerName: "FeeBalance",
        field: "feeBalance",
        width: 160
    },
    {
        headerName: "InactiveClients",
        field: "inactiveClients",
        width: 160,
    },
    {
        headerName: "Fusions",
        field: "fusions",
        width: 160,
    },
    {
        headerName: "DemosBooked",
        field: "demosBooked",
        width: 160
    },
    {
        headerName: "NewJoining",
        field: "newJoining",
        width: 160,
    },
    {
        headerName: "UpcomingRenewals",
        field: "upcomingRenewals",
        width: 160,
    },
    {
        headerName: "Review",
        field: "review",
        width: 160
    },
    {
        headerName: "ActiveClients",
        field: "activeClients",
        width: 160,
    },
    {
        headerName: "Fit",
        field: "fit",
        width: 160,
    },
    {
        headerName: "Date",
        field: "date",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];